// extracted by mini-css-extract-plugin
export default {"wrapper":"Captcha_wrapper--JGW","button":"Captcha_button--tFk"};